import React from "react";
import { useTranslation } from "react-i18next";
import { resumeProfile } from "../constants/resumeProfile";

function renderList(items) {
  return (
    <ul className="resumeWindowList">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

export default function ResumeWindowContent({ sectionId }) {
  const { t } = useTranslation("aiPortfolio");
  const localizedSummaryParagraphs = t("resume.summaryParagraphs", { returnObjects: true });
  const summaryParagraphs = Array.isArray(localizedSummaryParagraphs)
    ? localizedSummaryParagraphs
    : Array.isArray(resumeProfile.summaryParagraphs)
    ? resumeProfile.summaryParagraphs
    : [resumeProfile.summary || ""];

  if (sectionId === "resume_contacts") {
    return (
      <div className="resumeWindowContent">
        <p className="resumeWindowTitle">{t("resume.contactsTitle")}</p>
        <div className="resumeWindowLinks">
          {resumeProfile.contacts.map((contact) => (
            <a key={contact.label} href={contact.href} target="_blank" rel="noreferrer">
              <strong>{contact.label}:</strong> {contact.value}
            </a>
          ))}
        </div>
      </div>
    );
  }

  if (sectionId === "resume_skills") {
    return (
      <div className="resumeWindowContent">
        <p className="resumeWindowTitle">{t("resume.skillsTitle")}</p>
        {renderList(resumeProfile.highlights)}
      </div>
    );
  }

  if (sectionId === "resume_experience") {
    return (
      <div className="resumeWindowContent">
        <p className="resumeWindowTitle">{t("resume.experienceTitle")}</p>
        {renderList(resumeProfile.recentExperience)}
      </div>
    );
  }

  if (sectionId === "resume_education") {
    return (
      <div className="resumeWindowContent">
        <p className="resumeWindowTitle">{t("resume.educationTitle")}</p>
        {renderList(resumeProfile.education)}
        <p className="resumeWindowSubtitle">{t("resume.languagesTitle")}</p>
        {renderList(resumeProfile.languages)}
      </div>
    );
  }

  return (
    <div className="resumeWindowContent">
      <a
        className="resumeWindowName resumeWindowNameLink"
        href={resumeProfile.profileUrl}
        target="_blank"
        rel="noreferrer"
      >
        {resumeProfile.name}
      </a>
      <p className="resumeWindowRole">{t("resume.role", { defaultValue: resumeProfile.role })}</p>
      {summaryParagraphs.map((paragraph) => (
        <p key={paragraph}>{paragraph}</p>
      ))}
    </div>
  );
}
